
import PageGuideSlide from '@/components/pageGuide/PageGuideSlide.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Resale',
  components: { PageGuideSlide },
})
